import { wccModules } from 'enums/wccModules';
import { AppearBindingOptions } from 'extensions/knockout/bindings/appear';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import { Person } from 'models/person';
import { TopicThread } from 'models/topicThread';
import './creatorCover.html';
import './creatorCover.scss';

const { now } = settings;
const animationDuration = 500;

export interface CommentCreatorCoverVMConfig {
    comment: SubscribableOrNullableValue<TopicThread>
    active: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class CommentCreatorCoverVM {
    comment: Subscribable<TopicThread | undefined>

    avatarUrl: Subscribable<string | undefined>
    creatorName: Subscribable<string | undefined>
    createDateStr: Subscribable<string | undefined>

    appearSettings: AppearBindingOptions

    isNeeded: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentCreatorCoverVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        this.comment = ko.flattenComputed(config.comment);
        const isActive = ko.flattenComputed(config.active, false);

        const createDate = this.comment.pluck(c => c.createDate);
        this.createDateStr = createDate.mapNotNull(date => moment(date).from(now()));    

        const participant = this.comment.mapNotNull(comment => Person.fromThread(comment));
        this.avatarUrl = participant.pluck(p => p.imageURL);
        this.creatorName = participant.pluck(p => p.nicknameOrName);        

        const isHovered = ko.observable(false);
        const isVisible = ko.pureComputed(() => isActive() || isHovered()).extend({ rateLimit: { timeout: 150, method: 'notifyWhenChangesStop' } });

        this.appearSettings = { visible: isVisible, 'show-animation': 'slideInDown', 'hide-animation': 'slideOutUp', 'duration': animationDuration };

        this.isNeeded = isVisible.toFlag();

        ko.applyBindingsToNode(info.element, {
            'appear': {
                'visible': isVisible,
                'show-animation': 'none',
                'hide-animation': 'none',
                'duration': animationDuration
            },

            'css': {
                'topic__comment__creator-cover': true,
            },

            'event': {
                'mouseenter': () => isHovered(true),
                'mouseleave': () => isHovered(false)
            }
        }, this);
    }
}